<script setup lang="ts">
import type { PropType } from 'vue';

import type { BadgeTone } from '@/utils/badgeTone.ts';

defineProps({
  tone: {
    type: String as PropType<BadgeTone>,
    default: 'neutral',
  },
  variant: {
    type: String as PropType<'soft' | 'count'>,
    default: 'soft',
  },
  badgeLabel: {
    type: [String, Number],
    default: undefined,
  },
  flexDirection: {
    type: String,
    default: 'row',
  },
  clickable: {
    type: Boolean,
    default: false,
  },
  floating: {
    type: Boolean,
    default: false,
  },
  multiLine: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <q-badge
    class="a-badge"
    :class="[
      variant === 'count' ? 'a-badge--count' : `a-badge--${tone}`,
      clickable ? 'a-badge--clickable' : '',
      flexDirection,
    ]"
    :floating="floating"
    :multi-line="multiLine"
    :aria-label="badgeLabel"
  >
    <!-- The label renders between the icon slots instead of via q-badge's `label`
         prop (which would put it first in the DOM and set aria-label). -->
    <slot name="icon-before" />
    <slot name="badge-label">{{ badgeLabel }}</slot>
    <slot name="icon-after" />
    <slot name="default" />
  </q-badge>
</template>
